'use es6';

import ListRegistrations from '../models/ListRegistrations';
import { REQUESTED_LIST_REGISTRATIONS, RECEIVED_LIST_REGISTRATIONS, REQUESTED_LIST_REGISTRATIONS_FAILED } from '../actions/ActionTypes';
import { RequestStatus } from '../constants/base';
export default ((state = new ListRegistrations(), action) => {
  switch (action.type) {
    case REQUESTED_LIST_REGISTRATIONS:
      return state.set('status', RequestStatus.PENDING);
    case RECEIVED_LIST_REGISTRATIONS:
      {
        const reduced = action.payload.lists.reduce((acc, resp) => ({
          emailsNotSent: acc.emailsNotSent + resp.emailsNotSent,
          emailsSent: acc.emailsSent + resp.emailsSent,
          registered: acc.registered + resp.registered,
          unregistered: acc.unregistered + resp.unregistered
        }), {
          emailsNotSent: 0,
          emailsSent: 0,
          registered: 0,
          unregistered: 0
        });
        return state.merge({
          emailsNotSent: reduced.emailsNotSent,
          emailsSent: reduced.emailsSent,
          registered: reduced.registered,
          status: RequestStatus.SUCCEEDED,
          unregistered: reduced.unregistered
        });
      }
    case REQUESTED_LIST_REGISTRATIONS_FAILED:
      return state.set('status', RequestStatus.FAILED);
    default:
      return state;
  }
});